import { render } from "./createProposalComponent.vue?vue&type=template&id=187ba7f8&scoped=true"
import script from "./createProposalComponent.vue?vue&type=script&lang=js"
export * from "./createProposalComponent.vue?vue&type=script&lang=js"

import "./createProposalComponent.vue?vue&type=style&index=0&id=187ba7f8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-187ba7f8"]])

export default __exports__